export default [
  {
    name: 'shopMall',
    path: '/shop/mall',
    meta: { title: '店铺' },
  },
  {
    path: '/shop/cart',
    meta: { title: '购物车' },
    component: () =>
      import(/* webpackChunkName: "cart" */ '../../pages/shop/shopCart.vue'),
  },
  // {
  //   path: '/shop/shopCart',
  //   meta: { title: '购物车' },
  //   beforeEnter: async (to, from, next) => {
  //     newCartNavigate(to, next)
  //   },
  //   component: () =>
  //     import(/* webpackChunkName: "cart" */ '../../pages/shop/shopCart.vue'),
  // },
  {
    path: '/shop/commodityIndex',
    meta: { title: '商品管理' },
    component: () =>
      import(
        /* webpackChunkName: "commodityIndex" */ '../../pages/shop/commodityIndex.vue'
      ),
  },
  {
    path: '/shop/product',
    meta: { title: '商品详情' },
    component: () =>
      import(/* webpackChunkName: "product" */ '../../pages/shop/product.vue'),
  },
  {
    path: '/shop/showcase',
    meta: { title: '我的商品' },
    component: () =>
      import(
        /* webpackChunkName: "showcase" */ '../../pages/shop/showcase.vue'
      ),
  },
  {
    path: '/shop/promotion',
    meta: { title: '活动推广页' },
    component: () =>
      import(
        /* webpackChunkName: "showcase" */ '../../pages/shop/promotion.vue'
      ),
  },
  {
    path: '/shop/paySuccess',
    meta: { title: '支付成功' },
    component: () =>
      import(
        /* webpackChunkName: "showcase" */ '../../pages/shop/PaySuccess.vue'
      ),
  },
]
